
import { Vue } from "vue-class-component";

export default class EnterInAppBrowser extends Vue {
  viewName = "EnterInAppBrowser";
}
